import styled from 'styled-components';

export const PostContainer = styled.article`
  padding-top: 8rem;
  width: 85%;
  max-width: var(--max-width);
  border-bottom: 1px solid #dddddd;
  margin: 0 auto;

  h1 {
    font-size: 1.625rem;
    font-weight: 800;
    color: var(--highlight-blue);
    margin-bottom: 2.5rem;
    text-transform: uppercase;
  }

  @media (min-width: 1024px) {
    padding: 9.35rem 0 2.5rem;

    h1 {
      margin-bottom: 1.25rem;
      font-size: 2.25rem;
    }
  }
`;

export const PostWrapper = styled.div`
  max-width: 700px;
  margin: 0 auto;

  p {
    margin-bottom: 1.5rem;
    line-height: 1.8;
  }

  p,
  ul,
  ol {
    font-size: 1.125rem;
  }

  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Open Sans', sans-serif;
    margin-bottom: 1.5rem;
    font-size: 1.5rem;
  }

  ul {
    list-style-type: disc;
    padding: 0 0 0 40px;
    margin-bottom: 1.5rem;
  }

  ol {
    margin: 0 0 1.5rem;
  }

  li {
    list-style-type: unset;
    padding: unset;
  }

  img {
    width: 100%;
    object-fit: cover;
    margin-bottom: 3rem;
  }

  a {
    color: var(--highlight-blue);
    font-weight: 700;
    text-decoration: underline;
  }

  @media (min-width: 1024px) {
    p,
    a,
    strong {
      font-size: 1.125rem;
    }
  }
`;

export const Author = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  flex-wrap: wrap;
  row-gap: 1rem;
  font-weight: 700;
  padding-bottom: 2rem;
  border-bottom: 1px solid #a0a0a0;
  margin: 2rem 0 3rem;

  img {
    object-fit: contain;
    border-radius: 50%;
    margin-right: 0.625rem;
  }

  p {
    .name {
      font-weight: 700;
      display: inline-block;
      border-right: 1px solid #000;
      padding-right: 0.5rem;
      margin-right: 0.5rem;
    }

    .date {
      font-family: 'Jet Brains', monospace;
      font-size: 0.875rem;
      font-weight: 800;
      display: inline-block;
      border-right: 1px solid #000;
      padding-right: 0.5rem;
      margin-right: 0.5rem;
    }

    .duration {
      font-size: 0.875rem;
      font-weight: 400;
    }

    @media (min-width: 1024px) {
      margin-bottom: 0;
    }
  }
`;

export const Breadcrumbs = styled.div`
  margin-left: auto;

  font-family: 'Open Sans', sans-serif;
  font-size: 0.8rem;
  font-weight: 400;
  transition: color 0.3s ease-in-out;

  .separator {
    color: var(--highlight-blue);
  }

  a:hover {
    color: var(--highlight-blue);
  }
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1.5rem;

  .summary-link {
    text-decoration: underline;
    color: blue;
    font-size: 0.875rem;

    span {
      font-weight: 700;
    }
    &:hover {
      color: var(--highlight-blue);
    }
  }
`;
